// extracted by mini-css-extract-plugin
export default {"readMore":"Nc6zpcVT","mobile":"mobile","title":"FGWyYmMc","desktop":"desktop"};